<template>
	<div v-if="matching" :class="{'matching': true, 'narrow-label': narrowLabel}">
		<MatchingOverview
			:matching="matching"
			:clickable="true"
			:with-percentage="false"
			@click="$emit('click')"
		/>
	</div>
</template>

<script>
import Get from "@/api/customer/job-profile/applicant/matching/Get";
import AsyncQueue from "@/helper/async-queue/AsyncQueue";
import MatchingOverview from "@/vue/customer/job-profile/applicant/MatchingOverview.vue";

export default {

	components: {
		MatchingOverview,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: true,
		},
		inViewport: {
			type: Boolean,
			required: false,
			default: false,
		},
		narrowLabel: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data ()
	{
		return {
			loadedMatching: false,
			loadingMatching: true,
			matching: null,
		};
	},

	methods: {
		async loadMatching ()
		{
			if (this.loadedMatching)
			{
				return;
			}

			this.loadedMatching = true;

			this.loadingMatching = true;

			AsyncQueue.addProcess({
				execute: () =>
				{
					return new Get()
						.setJobProfileId(this.jobProfileId)
						.setJobId(this.jobId)
						.setPseudonymId(this.applicant.id)
						.setComparison(false)
						.call();
				},
				onFinish: ({result}) =>
				{
					this.matching = result.data.matching;

					this.loadingMatching = false;

					this.$emit('loaded');
				}
			});
		},
	},

	watch: {
		inViewport (inViewport)
		{
			if (inViewport && !this.loadedMatching)
			{
				this.loadMatching();
			}
		}
	}
}
</script>
